export const CARD_INFORMATION = [
    {
        id: 'GTX 1050',
        microarchitecture: 'Pascal - GP107',
        vram: 2,
    },
    {
        id: 'GTX 1080 Ti',
        microarchitecture: 'Pascal - GP102',
        vram: 11,
    },
    {
        id: 'RTX 2080 Ti',
        microarchitecture: 'Turing - TU102',
        vram: 11,
    },
    {
        id: 'RTX 3080',
        microarchitecture: 'Ampere - GA102',
        vram: 10,
    },
    {
        id: 'RTX 3090',
        microarchitecture: 'Ampere - GA102',
        vram: 24,
    },
    {
        id: 'RTX A6000',
        microarchitecture: 'Ampere - GA102',
        vram: 48,
    },
];

export const SNAPSHOT_STATUS = {
    SAVED: 0,
    CREATING: 1,
    SUCCEED: 2,
    ERROR: 3,
    RESTORING: 4
};

export const SNAPSHOT_STATUS_INFO = [
    //0: SAVED; 1: CREATING; 2: SUCCEED; 3: ERROR; 4: RESTORING
    {
        id: 0, 
        name: "Saved",
        color: "#409eff"
    },
    {
        id: 1,
        name: "Creating",
        color: "#e6a23c"
    },
    {
        id: 2,
        name: "Succeed",
        color: "#67c23a"
    },
    {
        id: 3,
        name: "Error",
        color: "#f56c6c"
    },
    {
        id: 4,
        name: "Restoring",
        color: "#e6a23c"
    }
];